export default {
  s: '%d秒',
  smicro: '%d秒',
  smid: '%d秒',

  ss: '%d秒',
  ssmicro: '%d秒',
  ssmid: '%d秒',

  m: '%d分鐘',
  mmicro: '%d分鐘',
  mmid: '%d分鐘',

  mm: '%d分鐘',
  mmmicro: '%d分鐘',
  mmmid: '%d分鐘',

  h: '%d小時',
  hmicro: '%d小時',
  hmid: '%d小時',

  hh: '%d小時',
  hhmicro: '%d小時',
  hhmid: '%d小時',

  d: '%d天',
  dmicro: '%d天',
  dmid: '%d天',

  dd: '%d天',
  ddmicro: '%d天',
  ddmid: '%d天',
};
